<template>
  <mdb-container>
    <mdb-row>
      <mdb-col col="12">
        <mdb-btn-group class="fixed-bottom mx-auto" style="width: 15em; opacity: 0.8">

          <mdb-btn  class="animated bounceInDown" v-if="showTel" tag="a" gradient="purple" floating size="lg" onClick="location.href='tel:4009302818'">
            <mdb-icon  icon="phone"/>
          </mdb-btn>
          <mdb-btn  class="animated bounceInDown" v-if="showEdit" tag="a" gradient="peach" floating size="lg"
                   onClick="location.href='http://www.gasheng.com/site/zxpgwap.html'">
            <mdb-icon icon="edit"/>
          </mdb-btn>
          <mdb-btn  class="animated bounceInDown" v-if="showTalk" tag="a" gradient="blue" floating size="lg"
                   onclick="window.open('http://p.qiao.baidu.com/cps/chat?siteId=10567090&userId=5378619&siteToken=b3bb58d66da33d73b607300262397c58')">
            <mdb-icon icon="comment-dots"/>
          </mdb-btn>

        </mdb-btn-group>

      </mdb-col>
    </mdb-row>

  </mdb-container>

</template>

<script>

  import {zaixianzixunM} from "../assets/js/mycommonALL"

  export default {
    name: 'MySider',
    methods: {
      zaixianzixunM
    },
    data() {
      return {
        showTel: false,
        showEdit: false,
        showTalk: false
      }
    },
    mounted() {
      let _this = this;
      (async function showIcon() {
        await new Promise(res => {
          setTimeout(() => _this.showTel = true, 1000);
          res();
        });
        await new Promise(res => {
          setTimeout(() => _this.showEdit = true, 1150)
          res();
        });
        await new Promise(res => {
          setTimeout(() => _this.showTalk = true, 1300)
          res();
        })
      })()
    }
  }
</script>

<style scoped>

</style>
